import _ from 'lodash';
import type { PrimeXProductType } from '../../../../../../types';
import type { RaterXPreset } from '../../api/types/rater-x-preset';
import type { RatingOptions } from '../../types';
import type { EditQuoteState } from '../../views/edit-quote/types';
import type { UnderwriteQuoteState } from '../../views/underwriter/types';
import { flattenModifiers } from './ratingOptions';
import { componentStateKey } from '../componentCoverages';
import type { Nullable } from '../../../../../../types/common/utility';
import type { CustomizeQuoteState } from '../../views/customize-quote/types';

export const formatComponentModifiersForState = (
  components: Nullable<RaterXPreset['components']>
) => {
  if (!components || _.isEmpty(components)) {
    return {};
  }

  const formattedCoverages: RatingOptions = {};

  for (const [productType, component] of Object.entries(components || {})) {
    const flattenedModifiers =
      flattenModifiers(component.rateModifierCategories) || [];

    for (const modifier of flattenedModifiers) {
      formattedCoverages[componentStateKey(modifier.key, productType)] = {
        ...modifier,
        productType: productType as PrimeXProductType,
        readOnly: !modifier.rules,
      };
    }
  }

  return formattedCoverages;
};

const mergeUwComponentRateModifiersIntoState = <
  T extends Partial<EditQuoteState & CustomizeQuoteState & UnderwriteQuoteState>
>(
  data: T
) => {
  if (!data.raterX?.components || _.isEmpty(data.raterX.components)) {
    return data;
  }

  const ratingOptions = formatComponentModifiersForState(
    data.raterX.components
  );

  return {
    ...data,
    ratingOptions: {
      ...data.ratingOptions,
      ...ratingOptions,
    },
  };
};

export default mergeUwComponentRateModifiersIntoState;
